export const APP_THEME = {
  DARK: 'dark',
  LIGHT: 'light'
}
